import PropTypes from 'prop-types';
import React, { memo, useCallback } from 'react';
import { SortableItem } from '../../decorators/SortableItem';
import { IconButton } from '../IconButton';

import style from './style.module.css';

/**
 * Stateless component for rendering a sorted row.
 *
 * @param props {Object}.
 * @param props.children {any} Children.
 * @param props.columnName {String} Column abbreviation.
 * @param props.direction {Number} Sort direction (1|-1).
 * @param props.onChangeSort {Function} To handle changing a sorting field.
 */
const SorterRow = props => {
  const {
    childProps: { columnName, direction, onChangeSort, order, defaultOrder },
    children,
    ...rest
  } = props;

  // We multiply by "-1" to get the inverted sort direction.
  const handleToggleDirection = useCallback(() => onChangeSort(columnName, direction * -1, true, order), [
    onChangeSort,
    columnName,
    direction,
    order,
  ]);

  const handleRemove = useCallback(() => onChangeSort(columnName, direction, false, defaultOrder), [
    onChangeSort,
    columnName,
    direction,
    defaultOrder,
  ]);

  return (
    <div {...rest} className={style.host}>
      <span className={style.label}>{children}</span>
      <IconButton
        icon={direction === 1 ? 'caret-up' : 'caret-down'}
        onClick={handleToggleDirection}
        size="sm"
        title="Change sort direction"
      />
      <IconButton icon="times" onClick={handleRemove} size="sm" title="Remove sorting" />
    </div>
  );
};

SorterRow.propTypes = {
  childProps: PropTypes.object,
  children: PropTypes.node,
};

const SorterRowSortable = SortableItem(SorterRow);

export default memo(SorterRowSortable);
